import { formatClock, formatMoment, plural } from './format'
import type { Scan, ScanState, ScanStep, ScanStepProgress, StepPhase, StepState } from './types'

/** Слова проверки: что идёт, на каком шаге и что именно отправлено, чего ждём, что получено (О-2). */

export const STEP_TITLES: Readonly<Record<ScanStep, string>> = {
  export: 'Выгрузка наименований из источника',
  map: 'Построение карты в службе поиска',
  compare: 'Сравнение: поиск пар',
}

export const STEP_STATE_TEXT: Readonly<Record<StepState, string>> = {
  pending: 'ещё не начат',
  running: 'идёт',
  waiting: 'ждёт',
  done: 'готово',
  failed: 'ошибка',
}

/** Что происходит на шаге: «отправлено» и «получено» — факты, «ждём» — ожидание; одно не выдаётся за другое. */
export const PHASE_TEXT: Readonly<Record<StepPhase, string>> = {
  sent: 'Запрос отправлен',
  'awaiting-response': 'Ждём ответ',
  received: 'Ответ получен',
  'awaiting-search': 'Ждём службу поиска',
  'awaiting-other-scan': 'Ждём окончания другой проверки этого источника',
}

export const SCAN_STATE_TEXT: Readonly<Record<ScanState, string>> = {
  running: 'Проверка идёт',
  waiting: 'Проверка ждёт',
  stopped: 'Проверка остановлена',
  completed: 'Проверка завершена',
  failed: 'Проверка прервалась',
}

/** Проверка занимает источник: вторую по нему не запустить (`DuplicateScanStates.IsActive`). */
export const isActive = (scan: Scan | null): boolean => scan !== null && (scan.state === 'running' || scan.state === 'waiting')

/** «128 из 5000» или просто «128», пока источник не сообщил общее число. */
export function stepNumbers(step: ScanStepProgress): string {
  return step.total === null ? `${step.done}` : `${step.done} из ${step.total}`
}

/** Доля шага 0…1; `null` — общее число неизвестно, полоса без процента. */
export function stepShare(step: ScanStepProgress): number | null {
  if (step.state === 'done') return 1
  if (step.total === null || step.total <= 0) return null
  return Math.min(1, step.done / step.total)
}

/** Когда служба сама повторит запрос к службе поиска: «повтор в 14:05:09». */
export function retryText(step: ScanStepProgress): string | null {
  return step.retryAt === null ? null : `повтор в ${formatClock(step.retryAt)}`
}

/** Итог готовой проверки (И-4): «Проверено 5000 наименований 23.10 14:05, найдено 128 пар (порог 90 %)». */
export function completedText(scan: Scan): string {
  const when = scan.finishedAt === null ? formatMoment(scan.startedAt) : formatMoment(scan.finishedAt)
  return `Проверено ${scan.itemCount} ${plural(scan.itemCount, 'item')} ${when}, найдено ${scan.pairCount} ${plural(scan.pairCount, 'pair')} (порог ${scan.threshold} %)`
}
